import { Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import useProtectedClient from '../../hooks/useProtectedClient';
import { getGoldBox } from '../../api/goldbox/goldBoxApi';
import ProductRowLoader from '../marketWidget/productRow/ProductRowLoader';
import { useNotification } from '../../context/NotificationProvider';
import GoldBoxItem from './GoldBoxItem';
import PureGoldItem from './PureGoldItem'
import GoldBoxWidget from './GoldBoxWidget';
const GoldBoxList = () => {
    const [isLoading, setIsLoading] = useState(true);
    const protectedClient = useProtectedClient();
    const {showNotification} = useNotification();
    const [pureGoldItems, setPureGoldItems] = useState([]);
    const [physicalItems, setPhysicalItems] = useState([]);
    const [totalGold, setTotalGold] = useState(0);
    const [totalMoney, setTotalMoney] = useState(0);
    const [goldPrice, setGoldPrice] = useState(0);
    const fetchGoldBox = async () => {
        try {
            const res = await getGoldBox(protectedClient);
            let pureGoldItemsArr = []
            let physicalItemsArr = []
            for(let item of res.items){
                if(item.productType === 0) {
                    pureGoldItemsArr.push(item)
                    setPureGoldItems(pureGoldItemsArr)
                }else{
                    physicalItemsArr.push(item)
                    setPhysicalItems(physicalItemsArr)
                }
            }
            setTotalGold(res.totalGoldWeight)
            setTotalMoney(res.totalValue)
            setGoldPrice(res.goldPriceSell)
        } catch (error) {
            showNotification(error, "error");
        } finally {
            setIsLoading(false);
        }
    };
    useEffect( () => {
        fetchGoldBox();
    }, []);
    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            padding={2}
            sx={{ 
                height: "90vh",
                width: "100%",
                marginBottom: "100px",
                overflowY: "auto",
                overflowX: "hidden",
            }}
        >
            {!isLoading
            ? 
                <>
                    <GoldBoxWidget totalGold={totalGold} totalMoney={totalMoney} goldPriceSell={goldPrice}/>
                    {
                        pureGoldItems.map((item, index) => (
                            <PureGoldItem key={index} item={item}/>
                        ))
                    }
                    {
                        physicalItems.map((item, index) => (
                            <GoldBoxItem key={index} item={item}/>
                        ))
                    }
                </> 
            :
                <>
                    <ProductRowLoader />
                    <ProductRowLoader />
                    <ProductRowLoader />
                </>
            }
            
        </Box>
    );
};

export default GoldBoxList;
